export class Payee {

	id: string;
	name: string;
	diff_business_name: string;
	entity_type: string;
	llc_tax_class: string;
  	other: string;
  	partnership: string;
	trust_estate: string;
	exempt_payee_code: string;
	fatca_exempt_code: string;
	address_1: string;
	address_2: string;
	city: string;
	state: string;
	zip: string;
	country: string;
	ssn: string;
	ein: string;
	itin: string;
	user_id: string;
	phone: string;
	email: string;
	country_of_citizenship: string;
	permanent_address: string;
	permanent_city: string;
	permanent_state: string;
	permanent_country: string;
	permanent_postal_code: string;
	foreign_tin: string;
	ref_number: string;
	date_of_birth: Date;
	residence_country: string;
	person_id: string;
	update_details_from_person: boolean;
	article_paragraph: string;
	withholding_percent: number;
	explanation: string;
	signer_printed: string;
	capacity: string;
	income_type: string;
	non_resident: boolean;
	account_numbers: string;
	//signature: Signature; //require a signature on the horse show level - not the payee level - generate a new signature each horse show, but keep the template of the payee the same

	 constructor(values: Object = {}) {
		Object.assign(this, values);
	}
	
}